import PersonalInformationProcessing from './personal-information-processing';

export default PersonalInformationProcessing;
